/**
 * The one way a message bubble prints its time, on both threads.
 *
 * It lived inside `chat/[id].tsx` while only the 1:1 thread had timestamps.
 * The group thread is getting them now — build 13 shipped a pending clock with
 * nothing to replace, so a group bubble changed height when a send landed —
 * and two copies of a formatter that decides bubble geometry is exactly the
 * kind of drift the shake came from. One implementation, one shape.
 *
 * Import-free apart from the platform `Intl`, so the root suites can drive it.
 */

/**
 * Returns "" for anything unusable rather than throwing or printing "Invalid
 * Date": the caller renders this straight into a bubble, and a malformed
 * server timestamp must not be able to put an error string in a conversation.
 */
export function formatMessageTime(value: string | null | undefined): string {
  if (!value) return "";
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return "";
  return new Intl.DateTimeFormat(undefined, {
    hour: "numeric",
    minute: "2-digit",
  }).format(date);
}
